import API from "../../../API/API";

const api = new API();

export const postSendOtpApi = (data) => {
  return api.post("send_otp", data);
};
